import React, { useCallback, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import {
  EventType,
  InteractionRequiredAuthError,
  PublicClientApplication,
} from "@azure/msal-browser";
import App from "./App";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "../src/Store/store";
import { Providers, ProviderState, SimpleProvider } from "@microsoft/mgt-react";

const pca = new PublicClientApplication({
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin, 
  },
});

const Root = () => {
  useEffect(() => {
    Providers.globalProvider = new SimpleProvider(
      () => Promise.resolve(window.localStorage.getItem("accessToken")),
      () => {
        Providers.globalProvider.setState(ProviderState.SignedIn);
      }
    );
    Providers.globalProvider.setState(ProviderState.SignedIn);

    const handleAuthCallback = async (event) => {
      if (
        event.eventType === EventType.LOGIN_SUCCESS &&
        event.payload.accessToken
      ) {
        window.localStorage.setItem("accessToken", event.payload.accessToken);
        Providers.globalProvider = new SimpleProvider(
          () => Promise.resolve(event.payload.accessToken),
          () => {
            Providers.globalProvider.setState(ProviderState.SignedIn);
          }
        );

        Providers.globalProvider.setState(ProviderState.SignedIn);
        pca.setActiveAccount(event.payload.account);
      }
    };

    const callbackId = pca.addEventCallback(handleAuthCallback);
    return () => {
      pca.removeEventCallback(callbackId);
    };
  }, []);

  const refreshToken = useCallback(async () => {
    try {
      const activeAccount = pca.getActiveAccount();
      if (!activeAccount) {
        throw new Error("No active account! Please log in.");
      }

      const response = await pca.acquireTokenSilent({
        scopes: ["https://api.powerplatform.com/.default"],
        account: activeAccount,
      });
      window.localStorage.setItem("accessToken", response.accessToken);
      Providers.globalProvider = new SimpleProvider(
        () => Promise.resolve(response.accessToken),
        () => {
          Providers.globalProvider.setState(ProviderState.SignedIn);
        }
      );
      Providers.globalProvider.setState(ProviderState.SignedIn);
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        // If silent token acquisition fails, fallback to interactive
        console.error("Silent token acquisition failed. Login required.");
      } else {
        console.error("Error refreshing token:", error);
      }
    }
  }, []);

  useEffect(() => {
    // Example of auto-refresh every 5 minutes
    const interval = setInterval(() => {
      refreshToken();
    }, 300000); // 5 minutes in milliseconds

    return () => clearInterval(interval);
  }, [refreshToken]);

  return (
    <BrowserRouter>
      <Provider store={store}>
        <App msalInstance={pca} />
      </Provider>
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root/>);
reportWebVitals();